import { createContext } from '@lit-labs/context';

const appContext = createContext(Symbol('tenable-app-context'));

export default appContext;
